import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import ChangeProfilePage, { getDefaultPageData, getDefaultPageUI } from "components/pages/ChangeProfilePage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";
import Classes from "model";

/**
 * @function CaptureChangeProfileBusinessSelected
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @description This component is used to capture ZLE in the 
 * context of MABI23 in the "Small Business" group.
 */
export default function CaptureChangeProfileBusinessSelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = useModel();
    const { options } = branding;
    const howIsZellePresented = options.present_zelle_abi22 ? options.present_zelle_abi22.toLowerCase() : undefined;

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "profileID" ], "1")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "showHeader" ], false)
    .submit();

    if(howIsZellePresented === "checkfree") {
        const message = `This capture is not shown when ABI22 branding option "How is Zelle Presented?" is set to "Checkfree".`;
        return <CaptureNotShownView message={ message }/>;
    }

    return <ChangeProfilePage data={ data } ui={ ui }/>;
}